var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[(_vm.IsPC)?_c('pc'):_c('phone')],1)}
var staticRenderFns = []

export { render, staticRenderFns }